import { drama } from '../../../constants/actionTypes';

const initState = false;

export default (state = initState, { type, hasMore }) => {
  switch (type) {
    case drama.FETCH_DRAMA_COMMENTS_SUCCESS:
      return Boolean(hasMore);

    case drama.CLEAN_COMMENTS:
      return initState;

    default:
      return state;
  }
};
